<template>
    <div id="main" class="select-modal">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>

        <div class="page">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">{{ $t('parametrizacoes') }}</h1>
                    <nav class="breadcrumb" aria-label="breadcrumbs">
                        <ul>
                            <li>
                                <a class="a-inativo">{{ $t('configs') }}</a>
                            </li>
                            <li>
                                <a aria-current="page">{{ $t('parametrizacoes') }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="header-buttons">
                    <button
                        v-if="permissao.create && abaSelecionada == 1"
                        class="save-btn"
                        type="button"
                        tag="button"
                        @click="showModalUsuarios()"
                    >
                        {{ $t('adicionar') }}
                    </button>
                </div>
            </div>
            <!-- ABAS -->
            <ul class="nav nav-tabs">
                <li
                    :class="{ active: abaSelecionada == i }"
                    @click="changeTab(i)"
                    :key="i"
                    v-for="(aba, i) in abas"
                >
                    <a data-toggle="tab" href="#parametrizacoes">{{ $t(aba) }}</a>
                </li>
            </ul>

            <!-- GERAL -->
            <div v-show="abaSelecionada == 0">
                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar :onSearch="debouncedOnSearch" tooltipLabel="informacao-campo-busca-parametrizacao" />
                    </div>

                    <div class="replicapda-select">
                        <vss-select
                            class="selecione-categoria"
                            title="selecione-categoria"
                            :options="categorias"
                            v-model="categoria"
                            @onBlurFunction="onCategoriaChanged"
                            tooltipLabel="informacao-campo-categoria-parametrizacao"
                            :height="40" 
                        />
                    </div>
                </div>

                <div class="registry-wrapper mt-5">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        responsive
                        v-else
                        :data="parametrizacoes"
                        class="data-table data-table-label-word-wrap"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'editar' ? $t(f.key) : ''"
                            :width="f.width"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div
                                v-if="
                                    f.key !== 'editar' &&
                                    f.key !== 'valor' &&
                                    f.key !== 'video_url_parametrizacao'
                                "
                                class="text-descricoes-lower block-with-text"
                            >
                                <span>{{ props.row[f.key] }}</span>
                            </div>
                            <div
                                v-else-if="
                                    f.key === 'editar' &&
                                    props.row.version_has_config === true &&
                                    permissao.update
                                "
                            >
                                <b-button
                                    icon-left="pencil"
                                    type="is-primary"
                                    style="
                                        border-radius: 6px;
                                        min-width: 40px;
                                        min-height: 40px;
                                        margin-top: 9px;
                                    "
                                    size="is-small"
                                    @click="showModal(props.row)"
                                    v-tippy 
                                    :title="$t('editar')"
                                />
                            </div>
                            <div v-else-if="f.key === 'valor'">
                                <div class="text-descricoes-upper">
                                    {{ props.row[f.key] }}
                                </div>
                            </div>
                            <div
                                v-else-if="
                                    f.key === 'editar' &&
                                    props.row.version_has_config === false &&
                                    permissao.create
                                "
                            >
                                <b-button
                                    icon-left="check"
                                    type="is-success"
                                    style="
                                        border-radius: 6px;
                                        min-width: 40px;
                                        min-height: 40px;
                                        margin-top: 9px;
                                    "
                                    size="is-small"
                                    @click="showModal(props.row)"
                                    v-tippy 
                                    :title="$t('config-nao-habilitada')"
                                />
                            </div>
                            <div
                                v-else-if="
                                    f.key === 'video_url_parametrizacao' &&
                                    props.row['video_url_parametrizacao']
                                "
                            >
                                <div @click="showModalVideo(props.row)">
                                    <b-icon
                                        icon="video"
                                        type="is-primary"
                                        style="margin-top: 13px"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('informacao-video-parametrizacao')"
                                    />
                                </div>
                            </div>
                        </b-table-column>
                    </b-table>

                    <!-- MODAL -->
                    <b-modal :active.sync="isShowingParametrizacao">
                        <ParametrizacaoModal
                            @fecharModal="closeModal"
                            @refresh="realoadTela"
                            :parametrizacao="parametrizacao"
                        />
                    </b-modal>

                    <!-- MODAL VIDEO -->
                    <b-modal :active.sync="isShowingParametrizacaoVideo" width="680">
                        <div class="bg">
                            <ParametrizacaoModalVideo
                                @fecharModal="closeModal"
                                :parametrizacao="parametrizacao"
                            ></ParametrizacaoModalVideo>
                        </div>
                    </b-modal>

                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>

            <!-- ESPECIFICAS -->
            <div v-show="abaSelecionada == 1">
                <div class="search-and-filter">
                    <div class="search-bar">
                        <search-bar
                            :onSearch="debouncedOnSearchUsuarios"
                            tooltipLabel="informacao-campo-busca-parametrizacao"
                        />
                    </div>

                    <div class="replicapda-select">
                        <vss-select
                            class="selecione-categoria"
                            title="selecione-categoria"
                            :options="categorias"
                            v-model="categoriaUsuario"
                            @onBlurFunction="onCategoriaUsuarioChanged"
                            tooltipLabel="informacao-campo-categoria-parametrizacao"
                            :height="40" 
                        />
                    </div>
                </div>

                <div class="registry-wrapper mt-5">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmptyEspecificas" />
                    <b-table
                        responsive
                        v-else
                        :data="parametrizacoesUsuarios"
                        class="data-table data-table-label-word-wrap remove-padding"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fieldsParametrizacaoUsuario"
                            :key="i"
                            :field="f.key"
                            :label="
                                f.key != 'editar' &&
                                f.key != 'version_has_config' &&
                                f.key != 'excluir'
                                    ? $t(f.key)
                                    : ''
                            "
                            :width="f.width"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key === 'descricao'">
                                <div class="text-descricoes-lower block-with-text">
                                    {{ props.row[f.key] }}
                                </div>
                            </div>
                            <div v-else-if="f.key === 'valor'">
                                <div class="text-descricoes-upper">
                                    {{ props.row[f.key] }}
                                </div>
                            </div>
                            <div v-else-if="f.key === 'usuarios'">
                                <div
                                    style="
                                        margin-left: auto;
                                        margin-right: auto;
                                        text-align: center;
                                        position: relative;
                                    "
                                >
                                    <div class="contagem" v-if="notificacaoQtd != 0">
                                        <span>
                                            {{ props.row['usuarios'] }}
                                        </span>
                                    </div>
                                    <b-icon
                                        v-if="props.row['usuarios'] != 0"
                                        class="has-badge-primary mt-3"
                                        icon="account"
                                        v-tippy 
                                        :title="$t('msg-tooltip-n-usuarios', { n: props.row['usuarios'] })"
                                    />
                                </div>
                            </div>
                            <div v-else-if="f.key === 'editar' && permissao.update">
                                <b-button
                                    icon-left="pencil"
                                    type="is-primary"
                                    style="
                                        border-radius: 6px;
                                        min-width: 40px;
                                        min-height: 40px;
                                        margin-top: 9px;
                                    "
                                    size="is-small"
                                    @click="showModalUsuarios(props.row)"
                                    v-tippy 
                                    :title="$t('editar')"
                                />
                            </div>
                            <div v-else-if="f.key === 'excluir' && permissao.delete">
                                <b-button
                                    icon-left="delete"
                                    type="is-danger"
                                    style="
                                        border-radius: 6px;
                                        min-width: 40px;
                                        min-height: 40px;
                                        margin-top: 9px;
                                    "
                                    size="is-small"
                                    @click="promprConfirmDelete(props.row)"
                                    v-tippy 
                                    :title="$t('excluir')"
                                />
                            </div>
                            <div v-else>
                                <div class="text-descricoes-lower block-with-text">
                                    {{ props.row[f.key] }}
                                </div>
                            </div>
                        </b-table-column>
                    </b-table>

                    <!-- MODAL CONFIGS POR USUARIO -->
                    <b-modal :active.sync="isShowingParametrizacaoUsuario">
                        <div class="bg">
                            <ParametrizacaoUsuarioModal
                                @fecharModal="closeModal"
                                :parametrizacaoUsuario="parametrizacaoUsuario"
                            ></ParametrizacaoUsuarioModal>
                        </div>
                    </b-modal>

                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="paginationUsuarios.resetPagination"
                        :totalItems="paginationUsuarios.totalRows"
                        :perPageOptions="paginationUsuarios.perPageOptions"
                        :optionStarted="paginationUsuarios.optionStarted"
                        @change="updatePaginationUsuarios"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ParametrizacaoService from '@/services/ParametrizacaoService';
import ParametrizacaoUsuarioService from '@/services/ParametrizacaoUsuarioService';
import CategoriaConfigService from '@/services/CategoriaConfigService';
import ParametrizacaoModal from '@/components/conta/parametrizacoes/ParametrizacaoModal';
import ParametrizacaoModalVideo from '@/components/conta/parametrizacoes/ParametrizacaoModalVideo';
import ParametrizacaoUsuarioModal from '@/components/conta/parametrizacoes/ParametrizacaoUsuarioModal';
import NovaParametrizacaoUsuarioModal from '@/components/conta/parametrizacoes/NovaParametrizacaoUsuarioModal';
import Message from '@/models/Message';
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ParametrizacaoModal,
        ParametrizacaoModalVideo,
        ParametrizacaoUsuarioModal,
        NovaParametrizacaoUsuarioModal,
        ContainerLoader,
    },
    data() {
        return {
            abaSelecionada: 0,
            abas: ['geral', 'especificas'],
            fields: [
                { key: 'label-tabela-usuario', width: 140, sortable: false, sortFn: null },
                { key: 'valor', width: 120, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                { key: 'video_url_parametrizacao', width: null, sortable: false, sortFn: null },
                { key: 'editar', width: 20, sortable: false, sortFn: null },
            ],
            fieldsParametrizacaoUsuario: [
                { key: 'label-tabela-usuario', width: 140, sortable: false, sortFn: null },
                { key: 'valor', width: 120, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: false, sortFn: null },
                {
                    key: 'usuarios',
                    width: 20,
                    sortable: false,
                    centered: true,
                    vcenter: true,
                    sortFn: null,
                },
                { key: 'editar', width: 20, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            paginationUsuarios: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            isEmptyEspecificas: false,
            msgs: [],
            parametrizacoes: [],
            parametrizacao: {},
            parametrizacoesUsuarios: [],
            parametrizacaoUsuario: {},
            service: new ParametrizacaoService(this.$http, this.$router),
            serviceUsuarios: new ParametrizacaoUsuarioService(this.$http, this.$router),
            serviceCategoriaConfig: new CategoriaConfigService(this.$http, this.$router),
            permissao: {},
            categorias: [{ id: 0, label: this.$t('todos') }],
            categoria: { id: 0, label: this.$t('todos') },
            categoriaUsuario: { id: 0, label: this.$t('todos') },
            debouncedOnSearch: null,
            queryFilter: '',
            queryFilterUsuarios: '',
            isShowingParametrizacao: false,
            isShowingParametrizacaoVideo: false,
            isShowingParametrizacaoUsuario: false,
            //   isShowingNewParametrizacaoUsuario:false,
            delete: null,
        };
    },
    created() {
        // Aba Geral
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        // Aba usuarios/especificas
        this.paginationUsuarios.perPage = this.paginationUsuarios.perPageOptions[
            this.paginationUsuarios.optionStarted
        ];

        this.permissao = this.hasPermissionAccess(
            'admin',
            'parametrizacoes',
            'config-parametrizacoes'
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'parametrizacoes' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            this.debouncedOnSearchUsuarios = this.debounce(this.onSearchUsuarios, 500);
            this.carregarDadosUsuarios();
            // @84599 - Chama o método para carregar as categorias
            this.carregarCategorias();
        }
    },
    methods: {
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados(this.pagination.currentPage);
        },
        changeTab(i) {
            this.abaSelecionada = i;
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.categoria.id,
                    this.queryFilter ? this.queryFilter : '.*'
                )
                .then(this.mapItems)
                .then((value) => {
                    this.parametrizacoes = value;
                    this.isEmpty = this.parametrizacoes.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar parametrizações.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idconfig: m.idconfig,
                    idcategoriaconfig: m.idcategoriaconfig,
                    nome: m.nome,
                    'label-tabela-usuario': m.label,
                    descricao: m.descricao,
                    valor: this.jsonFormatter(m.tipo, m.valor, m.nome),
                    tipo: m.tipo,
                    video_url_parametrizacao: m.video_url,
                    version_has_config: m.version_has_config,
                };
            });
        },
        jsonFormatter(tipo, valor, nome) {
            if (tipo) {
                let json = JSON.parse(tipo);
                if (json.type === 'select') {
                    let retorno = json.options.filter((e) => {
                        if (e.value === valor) {
                            return e.name;
                        }
                    });
                    // @84512 - Caso o array retornado não seja vazio, significa que está entre as opções possíveis.
                    if (retorno.length > 0) {
                        return retorno[0].name;
                    } else {
                        // @84512 - Caso o array volte vazio, significa que o parâmetro passado não está entre as opções disponíveis, significando que precisa de correção.
                        let correcao = {
                            nome: nome,
                            valor: json.options[0].value,
                        };
                        this.service.corrigeValor(correcao); // @84512 - Para chamar o update e atualizar o valor para um válido, no caso, o primeiro valor das options.
                        return json.options[0].name; // @84512 - Exibe o valor que será atualizado, o primeiro das options.
                    }
                } else {
                    return valor;
                }
            } else {
                return valor;
            }
        },
        onCategoriaChanged(val) {
            this.carregarDados(this.pagination.currentPage);
        },
        carregarCategorias() {
            this.serviceCategoriaConfig
                .findAllCombo('')
                .then((value) => {
                    if (value.status === 200) {
                        if (value.content) {
                            value.content.map((e) => {
                                this.categorias.push({
                                    id: e.idcategoriaconfig,
                                    label: e.nome,
                                });
                            });
                        }
                    } else {
                        this.categorias = [];
                        this.categoria = {};
                        this.msgs.push(new Message('error', 'msg-erro-load', true));
                    }
                })
                .catch((e) => {
                    this.categorias = [];
                    this.categoria = {};
                    console.error(e);
                });
        },
        showModal(parametrizacao) {
            this.isShowingParametrizacao = !this.isShowingParametrizacao;
            this.parametrizacao = parametrizacao;
        },
        showModalVideo(parametrizacao) {
            this.isShowingParametrizacaoVideo = !this.isShowingParametrizacaoVideo;
            this.parametrizacao = parametrizacao;
        },
        realoadTela() {
            this.isShowingParametrizacao = !this.isShowingParametrizacao;
            this.carregarDados(this.pagination.currentPage);
            this.msgs.push(new Message('success', 'sucesso-edit-parametrizacao', true));
        },
        closeModal(val) {
            if (val === 'edit') {
                this.isShowingParametrizacao = !this.isShowingParametrizacao;
            } else if (val == 'especifica' || val == 'nova') {
                this.isShowingParametrizacaoUsuario = !this.isShowingParametrizacaoUsuario;
                this.carregarDadosUsuarios(this.paginationUsuarios.currentPage);
            } else {
                this.isShowingParametrizacaoVideo = !this.isShowingParametrizacaoVideo;
            }
        },
        /*  INICIO dos Metodos da aba de configuracoes por usuarios/especificas */
        carregarDadosUsuarios(currentPage = 1) {
            if (currentPage == 1 && this.paginationUsuarios.currentPage != 1)
                this.paginationUsuarios.resetPagination = true;

            this.isLoading = true;

            this.serviceUsuarios
                .findAll(
                    currentPage - 1,
                    this.paginationUsuarios.perPage,
                    this.categoriaUsuario.id,
                    this.queryFilterUsuarios ? this.queryFilterUsuarios : '.*'
                )
                .then(this.mapItemsUsuarios)
                .then((value) => {
                    this.parametrizacoesUsuarios = value;
                    this.isEmptyEspecificas = this.parametrizacoesUsuarios.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as parametrizacoes.');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.paginationUsuarios.resetPagination = false;
                });
        },
        mapItemsUsuarios(body) {
            this.paginationUsuarios.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idconfigusuario: m.idconfigusuario,
                    'label-tabela-usuario': m.label,
                    descricao: m.descricao,
                    nome: m.nome,
                    idcategoriaconfig: m.idcategoriaconfig,
                    valorOriginal: m.valor,
                    valor: this.jsonFormatter(m.tipo, m.valor),
                    tipo: m.tipo,
                    usuarios: m.somaUsuarios,
                };
            });
        },
        updatePaginationUsuarios(value) {
            this.paginationUsuarios.resetPagination = false;
            this.paginationUsuarios.perPage = value.perPage;
            this.paginationUsuarios.currentPage = value.currentPage;
            this.carregarDadosUsuarios(value.currentPage);
        },
        onCategoriaUsuarioChanged(val) {
            this.carregarDadosUsuarios(this.paginationUsuarios.currentPage);
        },
        showModalUsuarios(parametrizacaoUsuario) {
            this.isShowingParametrizacaoUsuario = !this.isShowingParametrizacaoUsuario;
            this.parametrizacaoUsuario = parametrizacaoUsuario;
        },
        onSearchUsuarios(value) {
            this.queryFilterUsuarios = value;
            this.paginationUsuarios.currentPage = 1;
            this.carregarDadosUsuarios(this.paginationUsuarios.currentPage);
        },
        promprConfirmDelete(row) {
            this.delete = row;
            let message = this.$t('msg-confirmacao-exclusao-n', 
                { n: row['label-tabela-usuario'] }
            );
            this.$root.confirm({
                message: message,
                onConfirm: this.deleteParametrizacaoUsuario,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        deleteParametrizacaoUsuario() {
            this.isLoading = true;

            this.service
                .deleteParametrizacaoUsuario(this.delete)
                .then((body) => {
                    if (body.status === 200) {
                        this.carregarDadosUsuarios(this.paginationUsuarios.currentPage);
                        this.$root.showMessage('success', 'sucesso-deletar-parametrizacao');
                    } else {
                        this.$root.showMessage('error', 'erro-deletar-parametrizacao');
                    }
                })
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar as parametrizacoes.');
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        /*  FIM dos Metodos da aba de configuracoes por usuarios/especificas    */
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 15px 15px 20px;
    height: auto;

    .page {
        .nav.nav-tabs {
            margin-bottom: 5px;
            margin-top: 5px;
        }

        .flex-container {
            display: flex;
            justify-content: flex-end;
        }

        .text-descricoes-lower {
            font-size: 14px;
            letter-spacing: -0.6px;
            word-spacing: -0.2px;
            font-weight: 400;
            text-decoration: none;
            font-style: normal;
            font-variant: normal;
            text-transform: lowercase;
        }

        .text-descricoes-upper {
            font-size: 14px;
            letter-spacing: -0.6px;
            word-spacing: -0.2px;
            font-weight: 400;
            text-decoration: none;
            font-style: normal;
            font-variant: normal;
            text-transform: uppercase;
        }

        .search-and-filter {
            display: flex;
            justify-content: space-between;
            margin: 10px 0;

            .search-bar {
                width: 50%;
                padding-right: 10px;
            }

            .replicapda-select {
                width: 50%;
                div {
                    height: 40px;
                }
            }
        }

        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0px !important;
            }

            .replicapda-select {
                width: 100% !important;
            }

            .descricao-tabela-parametrizacao {
                font-size: 8px;
            }
        }
    }

    button {
        min-width: 100px;
    }

    .block-with-text {
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }

    .contagem {
        position: absolute;
        right: 0;
        top: 3;
        background-color: $green-alert;
        border-radius: 50%;
        line-height: 1;
        min-width: 18px;
        height: 18px;
        margin-top: 6px;
        margin-right: -10px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
            color: #fff;
            font-weight: bold;
            font-size: 10px;
            padding: 5px;
        }
    }
}
</style>
